module.exports = __webpack_public_path__ + "static/media/backgroundCardHeader.9e5485cd.svg";